﻿// import Menu from './Menu';
// import Header from './Header';
// import Carousel from './Carousel';
import Search from './Search';
// import Footer from './Footer';
import SubmitForm from './SubmitForm';
// import SubmitSuccess from './SubmitSuccess';
//import TestSearch from './TestSearch';
// import MapView from './MapView';
import ListView from './ListView';
// import * as $ from 'jquery';
// import Heritage from './Heritage';
// import ConsentCookie from './ConsentCookie';
import Cookies from './Cookies';
// import UserForm from './UserForm';
// import Comments from './Comments';
// import CommentsSuccess from './CommentsSuccess';
// import CustomScrollbar from './CustomScrollbar';
// import RelativeDate from './RelativeDate';

// import { WOW } from 'wowjs';
// import MapLoader from './MapLoader';

export default class Startup {
    // private _menu: Menu;
    // private _header: Header;
    // private _carousel: Carousel;
    private _search: Search;
    // private _footer: Footer;
    private _submitForm: SubmitForm;
    // private _submitSuccess: SubmitSuccess;
    //private _testSearch: TestSearch;
    // private _mapView: MapView;
    private _listView: ListView;
    // private _mapLoader: MapLoader;
    // private _heritage: Heritage;
    // private _consentCookie: ConsentCookie;
    private _cookies: Cookies;
    // private _userForm: UserForm;
    // private _comments: Comments;
    // private _commentsSuccess: CommentsSuccess;
    // private _customScrollbar: CustomScrollbar;
    // private _relativeDate: RelativeDate;

    // private _wow: WOW;

    run() {
        // this._wow = new WOW();
        // this._mapLoader = new MapLoader();
        this._cookies = new Cookies();

        // this._mapView = new MapView(this._mapLoader);
        this._listView = new ListView();
        this._search = new Search(this._listView, this._cookies);
        // this._menu = new Menu(this._search);
        // this._header = new Header(this._menu);
        // this._carousel = new Carousel(this._wow);
        // this._footer = new Footer(this._menu);
        this._submitForm = new SubmitForm();
        // this._submitSuccess = new SubmitSuccess(this._submitForm);
       // this._testSearch = new TestSearch();
        // this._comments = new Comments();
        // this._commentsSuccess = new CommentsSuccess(this._comments);
        // this._heritage = new Heritage(this._carousel, this._comments);
        // this._consentCookie = new ConsentCookie(this._cookies);
        // this._userForm = new UserForm();
        // this._customScrollbar = new CustomScrollbar();
        // this._relativeDate = new RelativeDate();

        (window as any).$ = (window as any).jQuery = $;

        /*
        $(document).ready(() => {
            $("body").removeClass("preload");
        });

        window.addEventListener('load', () => {
            this._wow.init();
        });
        */

    }
}
